import { createContext } from 'react';
import { LngLatBounds } from 'mapbox-gl';

export interface TileCoord {
    x: number;
    y: number;
    z: number;
}

export interface MapViewContextType {
    mapTileCoords: TileCoord[];
    setMapTileCoords: (coords: TileCoord[]) => void;
    viewportBounds: LngLatBounds | null;
    setViewportBounds: (bounds: LngLatBounds | null) => void;
    hoveredStateId: string | null;
    setHoveredStateId: (id: string | null) => void;
    mapName: string | null;
    setMapName: (name: string | null) => void;
    selectedTagIds: string[];
    setSelectedTagIds: (ids: string[]) => void;
    selectedCategoryIds: string[];
    setSelectedCategoryIds: (ids: string[]) => void;
    searchQuery: string | null;
    setSearchQuery: (query: string | null) => void;
    sidebarCollapsed: boolean;
    setSidebarCollapsed: (collapsed: boolean) => void;
    selectedStateId: string | null;
    setSelectedStateId: (id: string | null) => void;
}

export const MapViewContext = createContext<MapViewContextType>({} as MapViewContextType);
